import { useDispatch, useSelector } from 'react-redux';
import { Expandable2 } from '../../../../components/Expandable/Expandable2';
import Item from '../../../../components/Lists/Item';
import { NavBar } from '../../../../components/NavBar/NavBar';
import { SortingButton } from '../../../../components/Sorting/SortingButton';
import { SortingHeader } from '../../../../components/Sorting/SortingHeader';
import { SortingProvider } from '../../../../contexts/SortingContext';
import OrderDetails from './OrderDetails';
import './VendorApproval.scss';
import { approveOrder, fetchOrders, nextPage, rejectOrder, selectStatus, selectVAppLoading, selectVAppOrderBy, selectVAppPage, selectVAppSearch, selectVAppTotalPages, selectVendorOrders, updateOrderBy, updateSearch } from '../../../../redux/features/VendorModule/VendorApproval/VendorApprovalSlice';
import { useEffect, useRef, useState } from 'react';
import { DialogTrigger } from '../../../../components/Dialog/Dialog';
import CancelOrder from './CancelOrder';
import ApproveOrder from './ApproveOrder';
import { Tag } from '../../../../components/Tags/Tag';
import { useSnackBar } from '../../../../hooks/useSnackBar';
import { Dialog, DialogContent } from '@mui/material';
import CurrencyInput from 'react-currency-input-field';

const mockData = [
    { id: 0, orderType: "PO", status: "STV", orderNumber: "202508001", location: "MIA", site: "Warehouse 01", dateRequired: "2025-07-23", priority: "Medium", requestedBy: "Spirit Airlines", supplyChain: "9876542123", created: "2025-07-01", daysSince: "44", totalCost: "$1,500.00 USD" },

    {
        id: 1,
        orderType: "RO",
        status: "STV",
        orderNumber: "202508002",
        location: "LAX",
        site: "Receiving Dock A",
        dateRequired: "2025-07-25",
        priority: "High",
        requestedBy: "Delta Cargo",
        supplyChain: "1234567890",
        created: "2025-07-02",
        daysSince: "43",
        totalCost: "$2,750.00 USD"
    },
    {
        id: 2,
        orderType: "LO",
        status: "STV",
        orderNumber: "202508003",
        location: "JFK",
        site: "Logistics Hub 3",
        dateRequired: "2025-07-26",
        priority: "Low",
        requestedBy: "American Airlines",
        supplyChain: "4567891230",
        created: "2025-07-03",
        daysSince: "42",
        totalCost: "$980.00 USD"
    },
    {
        id: 3,
        orderType: "SO",
        status: "STV",
        orderNumber: "202508004",
        location: "ORD",
        site: "Outbound Bay 2",
        dateRequired: "2025-07-27",
        priority: "Medium",
        requestedBy: "United Express",
        supplyChain: "7890123456",
        created: "2025-07-04",
        daysSince: "41",
        totalCost: "$1,200.00 USD"
    },
    {
        id: 4,
        orderType: "PO",
        status: "STV",
        orderNumber: "202508005",
        location: "ATL",
        site: "Warehouse 02",
        dateRequired: "2025-07-28",
        priority: "High",
        requestedBy: "JetBlue Logistics",
        supplyChain: "3216549870",
        created: "2025-07-05",
        daysSince: "40",
        totalCost: "$3,100.00 USD"
    },
    {
        id: 5,
        orderType: "RO",
        status: "STV",
        orderNumber: "202508006",
        location: "SEA",
        site: "Receiving Dock B",
        dateRequired: "2025-07-29",
        priority: "Medium",
        requestedBy: "Alaska Air",
        supplyChain: "6543217890",
        created: "2025-07-06",
        daysSince: "39",
        totalCost: "$1,850.00 USD"
    }

]

const orderTypeIcon = {
    PO: "icon-cart_icon",
    RO: "icon-maintenance",
    LO: "icon-hands_greeting_icon",
    SO: "icon-service_icon"
}

export const OrderType = (item) => (
    <div className='ordertype'>
        <i className={orderTypeIcon[item["orderType"]]}></i>
        <span>{item["orderType"] || "--"}</span>
    </div>
)
export const Hlght = (item, key) => (
    <div className='ordertype highlight'>
        {/* <i className={orderTypeIcon[item["orderType"]]}></i> */}
        <span>{item[key] || "--"}</span>
    </div>
)
export const Bold = (item, key) => (
    <div className='ordertype'>
        {/* <i className={orderTypeIcon[item["orderType"]]}></i> */}
        <b style={{fontSize: "0.6rem"}}>{item[key] || "--"}</b>
    </div>
)

const VendorApproval = () => {
    const orders = useSelector(selectVendorOrders);
    const status = useSelector(selectStatus);
    const [approveInfo, setApproveInfo] = useState(null);
    const dispatch = useDispatch();

    const { infoMsg, successMsg } = useSnackBar();

    const approveOrderClick = (e, ordr, orderIdx) => {
        infoMsg("Approving order...", "", 1000);

        e.stopPropagation();

        // e.stopPropagation();
        dispatch(approveOrder({ orderId: ordr.id, orderIdx })).then(action => {
            console.warn('*action payload approve order', action.payload);
            if (action.payload) {
                setApproveInfo({ ...ordr, approvedBy: "Vendor(via Portal)", approvedDate: new Date().toISOString().slice(0, 10) });
            }
        });
    }

    const rejectOrderClick = (ordr, reason) => {
        infoMsg("Rejecting Order");
        dispatch(rejectOrder({ orderId: ordr.id, reason })).then(action => {
            if (action.payload) infoMsg("The order was rejected");
        });
    }


    const search = useSelector(selectVAppSearch);
    const orderBy = useSelector(selectVAppOrderBy);
    const page = useSelector(selectVAppPage);
    const totalPages = useSelector(selectVAppTotalPages);
    const loading = useSelector(selectVAppLoading);

    useEffect(() => {
        dispatch(fetchOrders({search, page, orderBy, companyId: parseInt(localStorage.getItem("u_company_id")) }));
    }, [search, page, orderBy]);
    
    const requestNextPage = () => {
        dispatch(nextPage());
    }

    const handleScroll = (event) => {
        const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
        if (scrollHeight - (scrollTop + 3) <= clientHeight) {
            if (!loading) {
                if (totalPages > (page)) requestNextPage();
            }
        }
    };

    return (
        <SortingContainer>
            {/* {JSON.stringify(orders)} */}
            <div className='vendor-approval-component'>
                <NavBar searchInputProps={{
                    onTextChange: (e) => dispatch(updateSearch({ search: e })),
                }} dataBreadCrumbs="/vendor/vendor-approval" moduleId={13} isLocalSearch searchActions={<><SortingButton></SortingButton></>} />
                <div className='v-app-content'>
                    {/* <FormattedInput/> */}
                    <SortingHeader></SortingHeader>
                    <div className='ordersTable' onScroll={handleScroll}>
                        {orders.map((ordr, idx) =>
                            <Expandable2 name="vendor-app-order" summary={
                                <Item valuePlaceholder="--" orderedProperties={["orderType", "id", "location", "site", "dateRequired", "priority", "requestedBy", "supplyChain", "createdDate", "daysSince", "totalCostMapped"]} renderProperty={{ "orderType": OrderType, "daysSince": Hlght, "totalCostMapped": Bold }} ignoreProperties={["status"]} lightFont hideLabels key={ordr} item={ordr}>
                                    {/* <Item renderProperty={{ "orderType": OrderType, "daysSince": Hlght }} ignoreProperties={["id", "status"]} lightFont hideLabels key={ordr} item={ordr}> */}
                                    <div className='item-actions'>
                                        {
                                            status[ordr.id] === "Sent To Vendor" && <>
                                                <DialogTrigger dialogContent={{ component: CancelOrder, props: { onCancel: (reason) => rejectOrderClick(ordr, reason) } }}>
                                                    <button className='orderactionbutton cancel'>
                                                        <i className='icon-light-cross'></i>
                                                    </button>
                                                </DialogTrigger>
                                                {/* <DialogTrigger dialogContent={{ component: ApproveOrder }}> */}
                                                <button className='orderactionbutton ok' onClick={(e) => approveOrderClick(e, ordr, idx)}>
                                                    <i className='icon-check-2' style={{ pointerEvents: 'none' }}></i>
                                                </button>
                                                {/* </DialogTrigger> */}

                                            </>
                                        }

                                        {status[ordr.id] === "Vendor Approved" && <Tag type="success" tag="Approved" />
                                        }
                                        {status[ordr.id] === "Cancelled" && <Tag type="error" tag="Cancelled" />
                                        }
                                    </div>
                                </Item>

                            }>
                                <OrderDetails orderId={ordr.id} />

                            </Expandable2>

                        )}
                    </div>
                    <Dialog onClose={() => setApproveInfo(null)} open={approveInfo} BackdropProps={{ style: { backdropFilter: 'blur(5px)', background: "rgba(0,0,0,0.5)" } }}
                        PaperProps={{

                            sx: {
                                borderRadius: '12px',
                                // boxShadow: 'var(--pop-over-shadow)'
                                maxWidth: '95vw',
                                // padding: '1rem'
                                // background: "magenta"
                            }

                        }}>
                        <DialogContent>
                            <ApproveOrder order={approveInfo} okClick={() => setApproveInfo(null)} />
                        </DialogContent>
                    </Dialog>

                </div>

            </div>
        </SortingContainer>
    )
}

const SortingContainer = ({ children }) => {
    const dispatch = useDispatch();

    return (
        <SortingProvider onOrderChange={(e) => dispatch(updateOrderBy({orderBy:e}))} properties={{ orderType: "Order Type", id: "Order Number", location: "Location", site: "Site", dateRequired: "Date Required", priority: "Priority", requestedBy: "Buyer", supplyChain: "Supply Chain", createdDate: "Created", daysSince: "Days Since", totalCost: "Total Cost" }}>
            {children}
        </SortingProvider>
    )

}

export default VendorApproval;